import { render, staticRenderFns } from "./Top10TitleSwiper.vue?vue&type=template&id=0a996850&scoped=true"
import script from "./Top10TitleSwiper.vue?vue&type=script&setup=true&lang=ts"
export * from "./Top10TitleSwiper.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Top10TitleSwiper.vue?vue&type=style&index=0&id=0a996850&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a996850",
  null
  
)

export default component.exports